import React, { Component, createRef, Fragment } from "react";
import "./newEmployee.css";

//services
import { EmployeeSampleServices, PermissionServices, } from "../../services";

//components
import PageHeader from "../../components/Page/PageHeader/PageHeader";
import Loading from '../../components/Common/Loading'

class NewEmployee extends Component {
  state = {
    action: "",
    _id: "",
    totreq: false,
    isLoading: false,
    newEmp: [],
    newListEmp: [],
    scroll: true,
    page: 1,
    status: "",
    hasMoreData: true
  };

  scrollRef = createRef();

  async componentDidMount() {
    const { action, _id } = this.props.location.state;

    if (action == "view") {
      this.setState({
        isLoading: true
      })

      await this.getSingleEmployee(_id);
      await this.getListSingleEmployee(_id);

      this.loadMore();
      const container = this.scrollRef.current;
      if (container) {
        container.addEventListener('scroll', this.debouncedHandleScroll);
      }
    }

    this.setState({ action, _id });


  }

  componentWillUnmount = () => {
    const container = this.scrollRef.current;
    if (container) {
      container.removeEventListener('scroll', this.debouncedHandleScroll);
    }
  };

  debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };


  getSingleEmployee = id => {
    EmployeeSampleServices.newEmployee(id)
      .then(response => {
        if (response.status === 200) {
          this.setState({
            newEmp: response.text.data,
            isLoading: false
          });
        }
        response.status == 401 && this.props.unauthorisedFunc()
      })
      .catch(error => this.props.getalertMessage("error", error.toString()));
  }

  getListSingleEmployee = id => {
    EmployeeSampleServices.newEmployeeListTable(id)
      .then(response => {
        if (response.status === 200) {
          this.setState({
            newListEmp: response.text.data,
            isLoading: false
          });
        }
        response.status == 401 && this.props.unauthorisedFunc()
      })
      .catch(error => this.props.getalertMessage("error", error.toString()));
  }

  getStatusList = newstatus => {
    this.setState({
      isLoading: true,
      status: newstatus,
      page: 1,
      newListEmp: [],
      hasMoreData: true
    });

    const { _id } = this.props.location.state;

    // EmployeeSampleServices.newEmployeeStatusTable(_id, status)
    EmployeeSampleServices.newEmployeeListStatusTable(_id, newstatus, 1)
      .then(response => {
        if (response.status === 200) {
          const newDatas = response.text.data;
          this.setState({
            newListEmp: newDatas,
            page: 2,
            isLoading: false,
            hasMoreData: newDatas.length >= 100
          });
        }
        response.status == 401 && this.props.unauthorisedFunc()
      })
      .catch(error => this.props.getalertMessage("error", error.toString()));
  }


  async loadMore() {
    
    const { page, newListEmp, status, hasMoreData } = this.state;
    const { _id } = this.props.location.state;

    const nextPage = page;
    const currList = [...newListEmp];

    if(!hasMoreData) {
      return;
    }

    this.setState({
      isLoading: true
    });

    if (status === "") {
      EmployeeSampleServices.newEmployeeScrollListTable(_id, nextPage)
        .then(response => {
          if (response.status === 200) {
            const newDatas = response.text.data;
            this.setState({
              newListEmp: [...currList, ...newDatas],
              page: nextPage + 1,
              isLoading: false,
              hasMoreData: newDatas.length >= 100
            });
          }
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => this.props.getalertMessage("error", error.toString()));
    } else {

      EmployeeSampleServices.newEmployeeListStatusTable(_id, status, nextPage)
        .then(response => {
          if (response.status === 200) {
            const newDatas = response.text.data;
            this.setState({
              newListEmp: [...currList, ...newDatas],
              page: nextPage + 1,
              isLoading: false,
              hasMoreData: newDatas.length >= 100
            });
          }
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => this.props.getalertMessage("error", error.toString()));
    }
  }


  handleScroll = () => {
    // const bottom = e.target.scrollHeight <= (e.target.scrollTop + e.target.clientHeight + 40);
    // if (bottom && this.state.scroll) {
    //   const nextPage = this.state.page + 1;
    //   this.setState({ scroll: false, page: nextPage });

    //   this.setState({ scroll: true });
    // }

    const container = this.scrollRef.current;
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollTop + clientHeight >= scrollHeight - 100 && !this.state.isLoading) {
      this.loadMore();
    }
  };

  debouncedHandleScroll = this.debounce(this.handleScroll, 200);



  render() {

    const { newEmp, newListEmp } = this.state;

    console.log(newListEmp, "newListEmp");


    return (
      <Fragment>
        {this.state.isLoading && <Loading />}
        <div class="right-section bg-white">
          <div class="row nopadding">
            <div class="col-md-12 nopadding">
              <div
                class="card-filter meeting-min-con"
                style={{ marginBottom: "0.5%" }}
              >
                <div class="row fabric-list-con">
                  <PageHeader
                    history={this.props.history}
                    header={"NEW EMPLOYEE DETAILS"}
                  />
                </div>
              </div>
              <div
                class="card-filter meeting-min-con"
                style={{ marginBottom: "0.5%" }}
              >
                <div class="row fabric-list-con">
                  <div
                    class="col-md-12 product-form"
                    style={{ paddingBottom: "1%" }}
                  >
                    {
                      newEmp.length > 0 ?
                        (newEmp || []).map((emp) => {
                          const { totalRequests, completedCount, pendingCount, cancelCount, inProcessCount, noAssignCount } = emp || {};
                          return (
                            <Fragment>
                              <div className="col-md-3">
                                <div className="box-con" onClick={() => this.getStatusList("")}>
                                  <div className="cart-list">
                                    <p>Total requests</p>
                                    <span>{totalRequests || 0}</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="box-con" onClick={() => this.getStatusList("COMPLETED")}>
                                  <div className="cart-list">
                                    <p>Completed</p>
                                    <span>{completedCount || 0}</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="box-con" onClick={() => this.getStatusList("PENDING")}>
                                  <div className="cart-list">
                                    <p>Pending</p>
                                    <span>{pendingCount || 0}</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="box-con" onClick={() => this.getStatusList("CANCEL")}>
                                  <div className="cart-list">
                                    <p>Cancel</p>
                                    <span>{cancelCount || 0}</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="box-con" onClick={() => this.getStatusList("IN PROCESS")}>
                                  <div className="cart-list">
                                    <p>In Process</p>
                                    <span>{inProcessCount || 0}</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="box-con" onClick={() => this.getStatusList("")}>
                                  <div className="cart-list">
                                    <p>No Assign</p>
                                    <span>{noAssignCount || 0}</span>
                                  </div>
                                </div>
                              </div>
                            </Fragment>
                          )
                        }) : <Fragment>
                          <Fragment>
                            <div className="col-md-3">
                              <div className="box-con">
                                <div className="cart-list">
                                  <p>Total requests</p>
                                  <span>0</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="box-con">
                                <div className="cart-list">
                                  <p>Completed</p>
                                  <span>0</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="box-con">
                                <div className="cart-list">
                                  <p>Pending</p>
                                  <span>0</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="box-con">
                                <div className="cart-list">
                                  <p>Cancel</p>
                                  <span>0</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="box-con">
                                <div className="cart-list">
                                  <p>In Process</p>
                                  <span>0</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="box-con">
                                <div className="cart-list">
                                  <p>No Assign</p>
                                  <span>0</span>
                                </div>
                              </div>
                            </div>
                          </Fragment>
                        </Fragment>
                    }
                  </div>
                </div>
              </div>
              <div class="table-container" ref={this.scrollRef} style={{ height: "520px", overflowY: "auto" }}>
                <table class="striped list-table">
                  <thead>
                    <tr>
                      <th className={"position-top-stick"} rowSpan={2}>Request No</th>
                      <th className={"position-top-stick"} style={{ paddingBottom: "10px" }} colSpan={4}>Assigned Stages</th>
                    </tr>
                    <tr>
                      <th className={"position-top-stick"} style={{ top: "28px" }}>Name</th>
                      <th className={"position-top-stick"} style={{ top: "28px" }}>Status</th>
                      <th className={"position-top-stick"} style={{ top: "28px" }}>ETA</th>
                      <th className={"position-top-stick"} style={{ top: "28px" }}>Process Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      (newListEmp || []).map((list, indextop) => {
                        const { requestNumber, assignedStages } = list || {};
                        return (
                          assignedStages.length > 0 && assignedStages.map((stage, indexin) => {
                            const { ETA, name, processDate, status } = stage || {};
                            return (
                              <tr key={`${indextop}-${indexin}`}>
                                {
                                  indexin === 0 && <td rowSpan={assignedStages.length || 1}>{requestNumber || "-"}</td>
                                }
                                <td>{name || "-"}</td>
                                <td>{status || "-"}</td>
                                <td>{ETA || "-"}</td>
                                <td>{processDate || "-"}</td>
                              </tr>
                            )
                          })
                        )
                      })
                      // <Fragment>
                      //   <tr>
                      //     <td rowSpan={assignedStages.length}>{requestNumber}</td>
                      //   </tr>
                      //   {
                      //     assignedStages.length > 0 && assignedStages.map((stage) => {
                      //       const {ETA, name, processDate, status} = stage || {};
                      //       return (
                      //         <tr>
                      //           <td></td>
                      //           <td>{name || "-"}</td>
                      //           <td>{status || "-"}</td>
                      //           <td>{ETA || "-"}</td>
                      //           <td>{processDate || "-"}</td>
                      //         </tr>
                      //       )
                      //     })
                      //   }
                      // </Fragment>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default NewEmployee;



// WEBPACK FOOTER //
// ./src/pages/newEmployee/page.js